export enum OrderStatus {
    created = 'created',
    paid = 'paid',
    canceled = 'canceled',
    refunded = 'refunded'
}
